const Swiper = require('./vendor/swiper.min');

const subscriptionsSwipers = document.querySelectorAll('.subscriptions-swiper');

subscriptionsSwipers.forEach((subscriptionsSwiper) => {
  const container = subscriptionsSwiper.querySelector('.swiper-container');
  new Swiper(container, { 
    autoHeight: true,
    loop: true,
    slidesPerView: 5,
    spaceBetween: 10,
    breakpoints: {
      780: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      590: {
        slidesPerView: 2,
        spaceBetween: 20
      }
    },
    navigation: {
      nextEl: subscriptionsSwiper.querySelector('.swiper-button-next'),
      prevEl: subscriptionsSwiper.querySelector('.swiper-button-prev'),
    },
    on: {
      init: function () {
        subscriptionsSwiper.classList.remove('unloaded');
      },
    }
  });
});
